import { tips } from "@/mocks/home";
import SectionHead from "./SectionHead";

function trustColor(trust: number) {
  if (trust >= 80) return { bar: "bg-accent-400", text: "text-accent-300", border: "border-accent-500/30", bg: "bg-accent-500/10" };
  if (trust >= 60) return { bar: "bg-secondary-400", text: "text-secondary-300", border: "border-secondary-500/30", bg: "bg-secondary-500/10" };
  return { bar: "bg-primary-400", text: "text-primary-300", border: "border-primary-500/30", bg: "bg-primary-500/10" };
}

export default function Insider() {
  return (
    <section className="relative bg-background-950 py-20 md:py-28">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHead
          kicker="知情人士线索墙"
          title="线索整理，标注可信度再上桌"
          desc="每一条匿名线索都会经过「可信度评估 + 交叉核实」再展示。评价低不代表虚假，只代表当前证据尚不足以支撑结论。"
        />

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {tips.map((tip) => {
            const tc = trustColor(tip.trust);
            return (
              <article
                key={tip.id}
                className="flex flex-col rounded-2xl border border-background-800 bg-background-900 p-6 transition-colors hover:border-background-600"
              >
                <div className="flex items-start justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <span className={`flex h-11 w-11 items-center justify-center rounded-full ${tc.bg} font-heading text-lg font-bold ${tc.text}`}>
                      {tip.who.replace("知情人士 · ", "").slice(0, 1)}
                    </span>
                    <div>
                      <p className="font-heading text-sm font-bold text-foreground-50">{tip.who}</p>
                      <p className="mt-0.5 text-xs text-foreground-500">
                        {tip.source} · {tip.code}
                      </p>
                    </div>
                  </div>
                  <span className={`rounded-full border px-2 py-0.5 text-[11px] font-medium ${tc.border} ${tc.text}`}>
                    可信度 {tip.trust}%
                  </span>
                </div>

                <p className="mt-5 flex-1 text-sm leading-relaxed text-foreground-300">“{tip.text}”</p>

                <div className="mt-5">
                  <div className="mb-2 flex items-center justify-between text-[11px] text-foreground-500">
                    <span>线索可信度</span>
                    <span className={`font-heading font-semibold ${tc.text}`}>{tip.trust}%</span>
                  </div>
                  <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-700">
                    <div className={`h-full rounded-full ${tc.bar}`} style={{ width: `${tip.trust}%` }}></div>
                  </div>
                </div>

                <div className="mt-6 flex items-center justify-between border-t border-background-800 pt-4">
                  <div className="flex items-center gap-1 text-foreground-400">
                    <button
                      type="button"
                      className="flex h-8 items-center gap-1.5 rounded-md px-2.5 text-xs transition-colors hover:bg-background-800 hover:text-foreground-100"
                    >
                      <i className="ri-thumb-up-line"></i> {tip.up.toLocaleString()}
                    </button>
                    <button
                      type="button"
                      className="flex h-8 items-center gap-1.5 rounded-md px-2.5 text-xs transition-colors hover:bg-background-800 hover:text-foreground-100"
                    >
                      <i className="ri-chat-3-line"></i> {tip.replies}
                    </button>
                  </div>
                  <button
                    type="button"
                    className={`flex items-center gap-1 whitespace-nowrap rounded-md px-2.5 py-1 text-xs font-medium ${tc.bg} ${tc.text} transition-opacity hover:opacity-80`}
                  >
                    跟评求证 <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}